import { Category } from '../types';

const defaults: Readonly<Category> = {
  canonicalTag: '',
  description: '',
  heading: '',
  hierarchy: [],
  seoCategories: [],
  id: 0,
  indexable: true,
  metaTagDescription: '',
  name: '',
  pageTitle: '',
  partnerImage: null,
};

export const categoryBuilder = (category?: Partial<Category>) => ({ ...defaults, ...category });
